import { Component, Input } from '@angular/core';
import {
  AlignmentEnum,
  BackgroundColorEnum,
  CmsComponentData,
  ImageText,
} from '@boels/models';
import { CommonModule } from '@angular/common';
import {
  DynamicContentLinkHandlerDirective,
  GenericLinkDirective,
  SafeCheckPipe,
  UrlTargetPipe,
} from '@boels/helpers';
import { GenericLinkComponent } from '../generic-link/generic-link.component';
import { RouterModule } from '@angular/router';
import { PrepareHtmlPipe } from '@boels/shared-state';
import { MediaComponent } from '../media/media.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'boels-image-text',
  templateUrl: './image-text.component.html',
  styleUrls: ['./image-text.component.scss'],
  imports: [
    CommonModule,
    MediaComponent,
    DynamicContentLinkHandlerDirective,
    GenericLinkComponent,
    SafeCheckPipe,
    RouterModule,
    UrlTargetPipe,
    PrepareHtmlPipe,
    ButtonComponent,
    GenericLinkDirective,
  ],
})
export class ImageTextComponent {
  @Input() componentData: CmsComponentData<ImageText>;

  getAlignment(imageAlignment: AlignmentEnum | undefined): boolean {
    return imageAlignment === AlignmentEnum.RIGHT;
  }

  getBackgroundColor(
    backgroundColor: BackgroundColorEnum | undefined,
  ): boolean {
    return backgroundColor === BackgroundColorEnum.GREY;
  }
}
